





















































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Enums from '@/lib/enums'

    class AddShelvesModel {
        startLetter: string;
        endLetter: string;
        startNumber: number | null;
        endNumber: number | null;
        startSuffix: number | null;
        endSuffix: number | null;
        separator: string;
        storeName: string;
        storeId?: number;
    }
@Component
export default class AddShelvesModule extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
    isDisplay: boolean;
  // 字母选项
   letters: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  // 表单数据
    formData: AddShelvesModel = {
    startLetter: '',
    endLetter: '',
    startNumber: null,
    endNumber: null,
    startSuffix: null,
    endSuffix: null,
        separator: '-',
        storeName: null,
        storeId: null

    };

  // 表单验证规则
   formRules = {
    letterRange: [{ validator: this.validateLetterRange, trigger: 'change' }],
    numberRange: [{ validator: this.validateNumberRange, trigger: 'change' }],
    suffixRange: [{ validator: this.validateSuffixRange, trigger: 'change' }]
  };

  // 验证字母范围
   validateLetterRange(rule: any, value: any, callback: Function) {
    if (!this.formData.startLetter || !this.formData.endLetter) {
      callback(new Error('请选择字母范围'));
    } else if (this.formData.startLetter > this.formData.endLetter) {
      callback(new Error('起始字母不能大于结束字母'));
    } else {
      callback();
    }
  }

  // 验证数字范围
   validateNumberRange(rule: any, value: any, callback: Function) {
    if (this.formData.startNumber === null || this.formData.endNumber === null) {
      callback(new Error('请输入数字范围'));
    } else if (this.formData.startNumber > this.formData.endNumber) {
      callback(new Error('起始数字不能大于结束数字'));
    } else {
      callback();
    }
  }

  // 验证后缀范围
   validateSuffixRange(rule: any, value: any, callback: Function) {
    if (this.formData.startSuffix === null || this.formData.endSuffix === null) {
      callback(new Error('请输入后缀范围'));
    } else if (this.formData.startSuffix > this.formData.endSuffix) {
      callback(new Error('起始后缀不能大于结束后缀'));
    } else {
      callback();
    }
  }

  // 生成货架号
   handleGenerate() {
    (this.$refs.form as any).validate((valid: boolean) => {
        if (valid) {
            this.$Modal.confirm({
                title: "添加货架", content: "确定要批量添加货架号？", onOk: async () => {
                    await this.$store.dispatch({
                        type: 'backShelves/Add',
                        data: this.formData
                    });
                    this.$Message.success('添加成功');
                    this.isDisplay = false;
                    this.$emit('input', this.isDisplay);
                }
            });
      } else {
          this.$Message.error('请检查输入是否正确');
      }
    });
  }
    close() {
        this.isDisplay = false;
        this.$emit('input', this.isDisplay);
    }
  
  // 重置表单
   handleReset() {
    (this.$refs.form as any).resetFields();
  }

      visibleChange(value: boolean) {
            this.isDisplay = value;
            if (!value) {
                this.$emit('input', value);
            } else {
                this.$set(this.formData, "storeName", this.$store.state.backShelves.storeName);
                this.$set(this.formData, "storeId", this.$store.state.backShelves.storeId);
            }
      }
}
